import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getTimeZone } from '../../../contexts/User/helpers/userContextHelpers';
import { userProviderPropsMap } from '../../../contexts/User/userProviderPropsMap';
import { sendRequestForOwnersApprove } from '../../../contexts/User/helpers/sendRequestForOwnersApprove';

export async function sendJoinRequest(flowAPI: ControllerFlowAPI) {
  const timeZone = getTimeZone(flowAPI);
  const userProvider = await userProviderPropsMap(flowAPI);
  const participant = await sendRequestForOwnersApprove(
    flowAPI,
    timeZone,
    // TODO: when do we need a startDate here?
    undefined,
  );

  await userProvider.updateParticipant(participant);

  return {
    participant: userProvider.participant,
  };
}
